module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cv-1ddd34244b91f9c46e1d60ea251e248c.svg";